function StampDateConverter(props){
    let date = new Date(props.data);

    return <>
        <span>{date.getFullYear()}年{date.getMonth()+1}月{date.getDate()}日</span>
    </>
}

export default StampDateConverter